module.exports = __webpack_public_path__ + "static/media/comp.9f95b009.png";